module.exports = __webpack_public_path__ + "static/media/Warranty.30dc326b.svg";